import { SignOutLogData } from '../../models';

export abstract class AbstractAuthEventService {
  abstract trackLogin(): void;
  abstract trackLogout(logData?: SignOutLogData): void;
  abstract trackLogoutAfterUnauthorized(logData: SignOutLogData): void;
}
